import { useEffect, useState } from "react";
import { UITextInput } from "..";

export default function UIPhoneNumberWithFormat(props) {
    // Create a new state to manage the state of the input
    const [ state, setState ] = useState("");
    const dataPoint = props.dataPoint ? { dataPoint: props.dataPoint } : {};
    // :: STRING, Event -> VOID
    // Whenever the user updates the text then restructure the value
    // to support the changes while maintaining the phone format
    const onChange = (value, evt) => {
        // Replace all non-integer values
        value = value.replace(/[^0-9]/g, "");
        // If the delete key was pressed then update the value by removing the last character
        if(evt.nativeEvent.inputType === "deleteContentBackward") {
            value = state.replace(/[^0-9]/g, "");
            value = value.slice(0, value.length - 1);
        }
        // Create the phone formatted string
        const areaCode = value.substring(0, 3).length > 0 ? `(${ value.substring(0, 3) })` : "";
        const firstThree = value.substring(3, 6).length > 0 ? ` ${ value.substring(3, 6) }` : "";
        const lastFour = value.substring(6, 10).length > 0 ? `-${ value.substring(6, 10) }` : "";

        value = `${ areaCode }${ firstThree }${ lastFour }`;
        // Update the state
        setState(value);
        // If there is an onChange property that is a function then call that method
        // passing the updated value
        if(props.onChange instanceof Function) {
            props.onChange(value);
        }
    }
    // If the value within the props has been updated, then update the state with the new value
    useEffect(() => {
        setState(props.value ?? "");
    }, [ props.value ]);

    return (
        <UITextInput
            placeholder={ props.placeholder }
            className="phone-text-field"
            value={ state }
            { ...dataPoint }
            onChange={ onChange } />
    );
}